import React, { JSX, useEffect } from 'react';

import { IStartToEndDateRanges } from '~/src/dash/components/calendar/common';
import { StartToEndDateRangePicker } from '~/src/dash/components/calendar/StartToEndDateRangePicker';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols, spacing, Text, usePublicaTranslation } from '~/src/dash/publicaUI';
import { resetMomentLocale, updateMomentLocale } from '~/src/locales/momentCfg';

interface IProps {
  cypressParentName: string;
  selectedRanges: IStartToEndDateRanges;
  handleApplyDateRanges: (ranges: IStartToEndDateRanges) => void;
  hasError?: boolean;
  labelWidth: number;
  labelHeight: number;
}

export const DateRange = ({
  cypressParentName,
  handleApplyDateRanges,
  hasError = false,
  selectedRanges,
  labelWidth,
  labelHeight,
}: IProps): JSX.Element => {
  const { t } = usePublicaTranslation();

  // move this to top wrapper when ready
  updateMomentLocale(t);

  // this resets it back to Sun-Sat on unmount
  useEffect(() => {
    return () => {
      resetMomentLocale();
    };
  }, []);

  return (
    <Cols
      gap={spacing.base}
      style={{ alignItems: 'center', minHeight: `${labelHeight}px` }}
      className={cypressParentName}
    >
      {/* LABEL */}
      <Col style={{ minWidth: `${labelWidth}px` }}>
        <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
          <Col displayFlex>
            <IconV2 name='calendar' small />
          </Col>
          <Col>
            <Text small bold tKey='DateRange' singleLineLabel />
          </Col>
        </Cols>
      </Col>
      <Col style={{ whiteSpace: 'nowrap' }}>
        <StartToEndDateRangePicker
          handleApply={handleApplyDateRanges}
          hasError={hasError}
          selectedRanges={selectedRanges}
        />
      </Col>
    </Cols>
  );
};
